import React from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svgs/download-icon.svg";
import { Button, Input, Checkbox } from "antd";

// Reports
const reportsList = [
  { label: "BRSR Report", value: "brsr_report" },
  { label: "ESG Report", value: "esg_report" },
  { label: "Social Report", value: "social_Report" },
  { label: "Governance Report", value: "governance_report" },
  { label: "Offsetgo ESG Report", value: "offsetgo_esg_Report" },
];

// Statuses
const statuses = [
  { label: "In Process", value: "in_process" },
  { label: "Completed", value: "completed" },
  { label: "Rejected", value: "rejected" },
];

// ✅ Status Style Handler
const getStatusStyles = (status) => {
  switch (status) {
    case "In Process":
      return {
        backgroundColor: "#45827659",
        color: "#000000",
        border: "1px solid #06513D",
      };
    case "Completed":
      return {
        backgroundColor: "#E8C45859",
        color: "#000000",
        border: "1px solid #E8C458",
      };
    case "Rejected":
      return {
        backgroundColor: "#6AA4F759",
        color: "#000000",
        border: "1px solid #6AA4F7",
      };
    default:
      return {
        backgroundColor: "#F3F4F6",
        color: "#374151",
        border: "1px solid #374151",
      };
  }
};

const FilterReport = ({ onOpen, onClose }) => {
  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className="text-lg text-[#06513D] underline px-4">Filter</h3>
        </div>

        <div
          style={{
            border: "1px solid #ebedf3",
            borderRadius: "10px",
            padding: "1rem",
          }}
        >
          {statuses.map((status) => (
            <div
              key={status.value}
              className="mb-8 mx-12 cursor-pointer transition duration-200"
              style={{
                borderRadius: "10px",
                padding: "10px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  ...getStatusStyles(status.label),
                  borderRadius: "9999px",
                  padding: "4px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "140px", // ✅ Optional fixed width
                }}
                disabled
              >
                {status.label}
              </button>
              {/* <Checkbox   style={{ accentColor: "#06513D" }}/> */}
              <input
                type="checkbox"
                className="h-4 w-4 mr-2 "
                style={{ accentColor: "#06513D" }}
              />
            </div>
          ))}
        </div>
        <div className="flex justify-center gap-4 mt-6 px-4">
          <Button
            onClick={onClose}
            className="border bg-[#E6EDEB] hover:text-[#06513D] border-[#06513D] text-[#06513D] hover:!bg-[#F8F8F8] hover:!border-[#06513D] "
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="bg-[#06513D] text-white hover:!bg-[#387464] border-none"
            onClick={() => {
              // TODO: handle filter save logic here
              onClose(); // close after saving (optional)
            }}
          >
            Save
          </Button>
        </div>
      </DialogBox>
    </div>
  );
};

export default FilterReport;
